import { v4 as uuidv4 } from 'uuid';
export default () => {
  const uuid = uuidv4()
  return {
    $id: uuid,
    valueType: 'date',
    FormItemProps: {
      label: '日期',
      name: uuid,
    }
  }
};
